import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, FileDown } from "lucide-react";
import { api, downloadFile, formatEuro } from "@/lib/api";

const Kpi = ({ label, value, accent, testid }) => (
  <div className="ff-card p-3">
    <span className="text-[11px] font-bold uppercase tracking-wide text-[#94A3B8]">{label}</span>
    <div data-testid={testid} className={`ff-display text-lg font-extrabold mt-1 ${accent || "text-white"}`}>{value}</div>
  </div>
);

export const ReportPanel = ({ open }) => {
  const [range, setRange] = useState({ date_from: "", date_to: "" });
  const [data, setData] = useState(null);
  const params = Object.fromEntries(Object.entries(range).filter(([, v]) => v));

  useEffect(() => {
    if (open) api.get("/reports/history", { params }).then((r) => setData(r.data)).catch(() => toast.error("Report non disponibile"));
  }, [open, range.date_from, range.date_to]); // eslint-disable-line react-hooks/exhaustive-deps

  const get = (ext) => downloadFile(`/reports/history.${ext}`, `fleetflow-report.${ext}`, params).catch(() => toast.error("Download non riuscito"));
  const t = data?.totals;

  return (
    <div data-testid="report-panel" className="flex flex-col gap-4">
      <div className="grid grid-cols-2 gap-2">
        <label className="block"><span className="ff-label">Dal</span><input type="date" data-testid="report-date-from" className="ff-field h-12" value={range.date_from} onChange={(e) => setRange((r) => ({ ...r, date_from: e.target.value }))} /></label>
        <label className="block"><span className="ff-label">Al</span><input type="date" data-testid="report-date-to" className="ff-field h-12" value={range.date_to} onChange={(e) => setRange((r) => ({ ...r, date_to: e.target.value }))} /></label>
      </div>
      {t && (
        <div className="grid grid-cols-2 gap-2">
          <Kpi label="Incassato (90%)" value={formatEuro(t.incassato)} accent="text-[#10B981]" testid="report-total-incassato" />
          <Kpi label="Pagato in Escrow" value={formatEuro(t.pagato)} testid="report-total-pagato" />
          <Kpi label="Commissioni (10%)" value={formatEuro(t.commissioni)} testid="report-total-commissioni" />
          <Kpi label="Corse / completate" value={`${t.corse} / ${t.completate}`} testid="report-total-corse" />
        </div>
      )}
      <div className="grid grid-cols-2 gap-2">
        <button type="button" data-testid="report-download-csv" onClick={() => get("csv")} className="ff-btn-secondary !min-h-[52px] text-sm uppercase border-[#10B981]"><FileSpreadsheet size={18} /> Excel / CSV</button>
        <button type="button" data-testid="report-download-pdf" onClick={() => get("pdf")} className="ff-btn-secondary !min-h-[52px] text-sm uppercase border-[#3B82F6]"><FileDown size={18} /> PDF</button>
      </div>
      <div className="flex flex-col gap-2" data-testid="report-rows">
        {data?.rows?.length === 0 && <p className="text-sm text-[#94A3B8] text-center py-6">Nessuna corsa nel periodo selezionato.</p>}
        {data?.rows?.map((r, i) => (
          <div key={`${r.riferimento}-${i}`} data-testid={`report-row-${i}`} className="ff-card p-3 text-sm flex flex-col gap-1">
            <div className="flex justify-between gap-2"><span className="font-bold text-white truncate">{r.tratta}</span><span className="text-[#94A3B8] shrink-0">{r.stato}</span></div>
            <div className="flex justify-between gap-2 text-[#CBD5E1]"><span>{r.data} • {r.ruolo}</span><span className="font-bold text-white">{formatEuro(r.tariffa)}</span></div>
          </div>
        ))}
      </div>
    </div>
  );
};
